import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Box } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useReport } from "../utils/useReport";
import { useInstallation } from "@services/servicesGenericsTables/useInstallation";
import { useClient } from "@services/servicesGenericsTables/useClients";
import { useSamplingReason } from "@services/servicesGenericsTables/useSamplingReason";
import { IFormReportInputs } from "@app/types/report.types";
import {
  ContainerSection,
  MAutocomplete,
  MButton,
  MDatePicker,
  ResponsiveFormContainer,
} from "@app/components";
import { getTypeReportOptions } from "../utils/helpers";

const FilterReport = () => {
  const { setQuery, referenceList } = useReport();
  const { installationList } = useInstallation();
  const { clientsList } = useClient();
  const { samplingReasonList } = useSamplingReason();

  const form = useForm<IFormReportInputs>({ mode: "all" });

  const submit = (data: IFormReportInputs) => {
    setQuery(data);
  };

  const clearFilters = () => {
    form.reset();
    setQuery({});
  };

  return (
    <ContainerSection label="Filtros">
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(submit)}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <ResponsiveFormContainer columns={5}>
              <MAutocomplete
                key={JSON.stringify(form.getValues("ref_report"))}
                name="ref_report"
                options={referenceList}
                label="Referencia Informe"
                getOptionLabel={(option: any) => option || ""}
              />

              <MAutocomplete
                key={JSON.stringify(form.getValues("type"))}
                name="type"
                options={getTypeReportOptions()}
                label="Seleccione un tipo de informe"
                getOptionLabel={(option: any) => option.label || ""}
              />
              <MAutocomplete
                key={JSON.stringify(form.getValues("client"))}
                name="client"
                options={clientsList}
                label="Seleccione un cliente"
                getOptionLabel={(option) => option.entidad}
              />
              <MAutocomplete
                key={JSON.stringify(form.getValues("installation"))}
                name="installation"
                options={installationList}
                label="Seleccione una instalación"
                getOptionLabel={(option) =>
                  `${option.codigo} - ${option.descripcion}`
                }
              />
              <MAutocomplete
                key={JSON.stringify(form.getValues("motivo_muestreo_id"))}
                name="motivo_muestreo_id"
                options={samplingReasonList}
                label="Seleccione un motivo"
                getOptionLabel={(option) =>
                  `${option.codigo} - ${option.descripcion}`
                }
              />
              <MDatePicker
                name="emission_date"
                pickerType="date"
                label="Fecha emisión desde"
              />
              <MDatePicker
                name="emission_date_end"
                pickerType="date"
                label="Fecha emisión hasta"
              />
            </ResponsiveFormContainer>
            <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
              <MButton
                variant="outlined"
                color="primary"
                sx={{ textTransform: "uppercase" }}
                text="Filtrar"
                type="submit"
                startIcon={<FilterAltIcon />}
              />
              <MButton
                variant="outlined"
                color="secondary"
                sx={{ textTransform: "uppercase", ml: 2 }}
                text="Limpiar"
                onClick={clearFilters}
              />
            </Box>
          </Box>
        </form>
      </FormProvider>
    </ContainerSection>
  );
};

export default FilterReport;
